import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPayoutAttachmentStatus.ts
var t = () => e("payoutAttachmentStatus");
//#endregion
export { t as useTrPayoutAttachmentStatus };
